import AiDocumentSummary from './AiDocumentSummary'

export default AiDocumentSummary
